import React from "react";
import {atom} from "jotai";

export const mp3UrlAtom = atom<string>("")


// React.RefObject<HTMLAudioElement>
export const audioRefAtom = atom<React.RefObject<HTMLAudioElement> | null>(null)